import PropTypes from 'prop-types'

import CheckBox from 'components/form/CheckBox'
import TextInput from 'components/form/TextInput'
import { useSelector } from 'react-redux'
import ErrorText from 'components/form/ErrorText'
import HelpTooltip from 'components/tooltip/HelpTooltip'

const LandingUrl = ({
  individual,
  mobileUrl,
  pcUrl,
  onChangeIndividual,
  onChangeMobileUrl,
  onChangePcUrl,
  title = '랜딩 URL',
  disabled,
  errors,
}) => {
  const { channel } = useSelector(state => state.creative.buildCreative)
  const disabledByChannel = {
    individual: !channel || channel.siteUrl.individualSettingYn === 'Y',
    pc:
      !channel ||
      (channel.siteUrl.individualSettingYn === 'Y' &&
        channel.siteUrl.pcSiteYn === 'N'),
    mobile:
      !channel ||
      (channel.siteUrl.individualSettingYn === 'Y' &&
        channel.siteUrl.mobileSiteYn === 'N'),
  }
  const handleIndividualChange = v => {
    onChangeIndividual(v)
    if (v) {
      onChangePcUrl(mobileUrl)
    } else if (mobileUrl === '') {
      onChangeMobileUrl(pcUrl)
    }
  }

  return (
    <div className="material_item">
      <div className="tit_itemwrap">
        <strong className="tit_item">{title}</strong>
      </div>
      <div className="desc_item">
        <div className="multi_row">
          <div className="subtit_itemwrap">
            <em className="subtit_item">
              {individual ? '모바일' : '모바일/PC'}
            </em>
            <HelpTooltip style={{ float: 'right' }} position="top alignRight">
              비즈채널 URL 개별 설정에 따라 활성화 여부가 결정됩니다.
            </HelpTooltip>
            <CheckBox
              label="개별 설정"
              checked={individual}
              onCheckedChange={handleIndividualChange}
              disabled={disabled || disabledByChannel.individual}
            />
          </div>
          <TextInput
            value={mobileUrl}
            onValueChange={onChangeMobileUrl}
            placeholder="http:// 또는 https:// 형식의 정상적인 랜딩 URL을 입력하세요."
            disabled={disabled || disabledByChannel.mobile}
            trim
            error={!disabledByChannel.mobile && errors.mobileUrl}
            hideLength
          />
          <ErrorText error={!disabledByChannel.mobile && errors.mobileUrl} />
        </div>
        {individual && (
          <div className="multi_row">
            <div className="subtit_itemwrap">
              <em className="subtit_item">PC</em>
            </div>
            <TextInput
              value={pcUrl}
              onValueChange={onChangePcUrl}
              placeholder="http:// 또는 https:// 형식의 정상적인 랜딩 URL을 입력하세요."
              disabled={disabled || disabledByChannel.pc}
              trim
              error={!disabledByChannel.pc && errors.pcUrl}
              hideLength
            />
            <ErrorText error={!disabledByChannel.pc && errors.pcUrl} />
          </div>
        )}
      </div>
    </div>
  )
}

export default LandingUrl

LandingUrl.propTypes = {
  individual: PropTypes.bool.isRequired,
  mobileUrl: PropTypes.string.isRequired,
  onChangeIndividual: PropTypes.func.isRequired,
  onChangeMobileUrl: PropTypes.func.isRequired,
  onChangePcUrl: PropTypes.func.isRequired,
  pcUrl: PropTypes.string.isRequired,
  title: PropTypes.string,
  disabled: PropTypes.bool,
  errors: PropTypes.shape({
    mobileUrl: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    pcUrl: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  }),
}
